import { toAbsoluteUrl } from '../../../../../_helpers';

export const languages = [
  {
    lang: 'en',
    label: 'EN',
    name: 'English',
    flag: toAbsoluteUrl('/media/svg/flags/260-united-kingdom.svg')
  },
  {
    lang: 'th',
    label: 'TH',
    name: 'ไทย',
    flag: toAbsoluteUrl('/media/svg/flags/238-thailand.svg')
  },
  {
    lang: 'zh-TW',
    label: 'ZH-TW',
    name: '繁體中文',
    flag: toAbsoluteUrl('/media/svg/flags/202-taiwan.svg')
  },
  {
    lang: 'zh-CN',
    label: 'ZH-CN',
    name: '简体中文',
    flag: toAbsoluteUrl('/media/svg/flags/015-china.svg')
  },
  {
    lang: 'ms',
    label: 'MY',
    name: 'Bahasa Melayu',
    flag: toAbsoluteUrl('/media/svg/flags/118-malasya.svg')
  },
  {
    lang: 'id',
    label: 'ID',
    name: 'Bahasa Indonesia',
    flag: toAbsoluteUrl('/media/svg/flags/004-indonesia.svg')
  },
  {
    lang: 'fil',
    label: 'FIL',
    name: 'Filipino',
    flag: toAbsoluteUrl('/media/svg/flags/192-philippines.svg')
  },
  {
    lang: 'ja',
    label: 'JA',
    name: '日本語',
    flag: toAbsoluteUrl('/media/svg/flags/063-japan.svg')
  },
  {
    lang: 'km',
    label: 'KM',
    name: 'ភាសាខ្មែរ',
    flag: toAbsoluteUrl('/media/svg/flags/159-cambodia.svg')
  },
  {
    lang: 'my',
    label: 'MM',
    name: 'မြန်မာ',
    flag: toAbsoluteUrl('/media/svg/flags/058-myanmar.svg')
  }
];
